import React from 'react';

import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';

import { ChildrenPropType } from '../../../../prop-types/children';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';

import style from './navigation-panel.module.less';

export const NavigationPanel = ({ children, headerMessageDescriptor, headerActionButton }) => {
  return (
    <div className={style['navigation-panel']}>
      <div className={style.header}>
        <Text className={style['header-text']} element='h2' textType={TextType.Label} value={headerMessageDescriptor} />
        {headerActionButton}
      </div>
      <div className={style['navigation-button-list']}>{children}</div>
    </div>
  );
};

NavigationPanel.propTypes = {
  children: ChildrenPropType.isRequired,
  headerMessageDescriptor: MessageDescriptorPropType.isRequired,
  headerActionButton: PropTypes.node.isRequired,
};
